import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedRd2sReducer(state = initialState.selectedRd2s, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_RD2S_SUCCESS:
      return action.selectedRd2s;
    default:
      return state;
  }
}
